import { useMemo, type ComponentProps } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalBody from 'LuxKit/Modal/ModalBody'
import Typography, { TYPOGRAPHY_LINE_HEIGHT_CSS_VAR } from 'LuxKit/Typography/Typography'
import { setCSSVar } from 'lib/theme/themeUtils'
import AccommodationRoomQuantityOptions from './AccommodationRoomQuantityOptions'

interface Props extends ComponentProps<typeof AccommodationRoomQuantityOptions> {
  title: string
}

const QuantityContent = styled(ModalContent)`
  padding-block-end: ${rem(12)};
`

const QuantityTitle = styled(Typography)`
  font-family: ${props => props.theme.font.primary.family};
  font-weight: ${props => props.theme.font.primary.weight.regular};
  font-size: 20px;
  ${setCSSVar(TYPOGRAPHY_LINE_HEIGHT_CSS_VAR, '24px')}
`

function AccommodationRoomQuantityModal({ title, label, ...props }: Props) {
  const headerTitle = useMemo(() => <QuantityTitle as="span" title={title} lineClamp={2}>{title}</QuantityTitle>, [title])

  return <ModalBase mode="default" height="auto">
    <ModalHeader title={headerTitle} />
    <ModalBody><QuantityContent flushVerticalTop>
      <AccommodationRoomQuantityOptions {...props} label={label} presentation="sheet" />
    </QuantityContent>
    </ModalBody>
  </ModalBase>
}

export default AccommodationRoomQuantityModal
